/* eslint-disable */
import type { firebase } from '../../firebase/firestore';

export interface IInteraction {
  action: IInteractionAction;
  /**
   * UUID v5
   */
  id: string;
  /**
   * Intents in `enquiry` Interaction
   */
  intents?: {
    availability?: firebase.firestore.Timestamp;
    brochure?: firebase.firestore.Timestamp;
    dates?: firebase.firestore.Timestamp;
    info?: firebase.firestore.Timestamp;
    other?: firebase.firestore.Timestamp;
    pricing?: firebase.firestore.Timestamp;
    quote?: firebase.firestore.Timestamp;
    showround?: firebase.firestore.Timestamp;
    videotour?: firebase.firestore.Timestamp;
  };
  /**
   * Messages in `enquiry` Interaction
   */
  messages?: {
    [k: string]: 'couple' | 'supplier';
  };
  /**
   * Optional Metadata
   */
  metadata?: {
    [k: string]: any;
  };
  /**
   * Temporal Boolean of Action Reversal
   */
  reverted: false | firebase.firestore.Timestamp;
  supplier: {
    id: string;
    type:
      | 'beauty'
      | 'cakes'
      | 'catering'
      | 'decoration'
      | 'dress'
      | 'entertainment'
      | 'florist'
      | 'group'
      | 'jewellery'
      | 'marquee'
      | 'menswear'
      | 'music'
      | 'photo'
      | 'planners'
      | 'stationery'
      | 'transport'
      | 'venue'
      | 'video';
  };
  timestamp: firebase.firestore.Timestamp;
  wedding: string;
}
/**
 * Interaction Message
 *
 * This interface was referenced by `IInteraction`'s JSON-Schema
 * via the `definition` "message".
 */
export interface IInteractionMessage {
  from: 'couple' | 'supplier';
  /**
   * Message Sent Time
   */
  time: firebase.firestore.Timestamp;
}

export enum IInteractionAction {
  BOOKING = 'booking',
  ENQUIRY = 'enquiry',
  SHORTLIST = 'shortlist',
  USED_SEARCH_CAROUSEL = 'used_search_carousel',
  VIEW = 'view',
  VIEWED_END_SCREEN_ON_SUPPLIER_PHOTO_CAROUSEL = 'viewed_end_screen_on_supplier_photo_carousel',
}
